export default __webpack_public_path__ + "static/media/icon_ui_checkbox_off.a4894a53.png";